import React from "react";
import { useEffect } from "react";
import { action_fetch_order_list_confirmed } from "../../../../../../../store/actions/pages/customer";
import { useStore } from "react-redux";
import { useParams } from "react-router-dom";
import { useQuery } from "../../../../../../hooks/common";
import { useSelector } from "react-redux";
import OrderList from "../fragments/order-list";
import OrderListEmpty from '../fragments/list-empty/index';
import { useCallback } from "react";
import { useDispatch } from "react-redux";

const OrderListConfirmed = props =>{
	const store = useStore();
	const params = useParams();
	const query = useQuery();
	const pageCustomer = useSelector(state=>state.pageCustomer);    
	const { orderListConfirmed } = pageCustomer;
	const dispatch = useDispatch();

	useEffect(async () => {
		if (window.__INITIAL_STATE__) {
			  // Allow the passed state to be garbage-collected
			  delete window.__INITIAL_STATE__
		  } else {
			if(orderListConfirmed?.data?.length <= 0){
				await OrderListConfirmed.fetchData(store, params, query)
			}
		  }
	}, []);

	const loadHandle = useCallback(() =>{
		dispatch(action_fetch_order_list_confirmed(false));
	}, []);

    return <div>
        <OrderList 
			request={loadHandle}
			orders={orderListConfirmed?.data} 
			loading={orderListConfirmed?.loading}
			finished={orderListConfirmed?.skip!==0 && orderListConfirmed?.finished}
		/>

		{
			orderListConfirmed?.skip===0 && orderListConfirmed?.finished && <OrderListEmpty />
		}
    </div>
}

OrderListConfirmed.fetchData = async (store, params, search, headers) => {
	await store.dispatch(action_fetch_order_list_confirmed(false, headers));
}

export default OrderListConfirmed;